import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TabsContext = /*#__PURE__*/createContext(undefined);
export const TabsProvider = ({
  actionsMenuStyleOverrides,
  buttonWrapperStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(TabsContext.Provider, {
    value: {
      actionsMenuStyleOverrides,
      buttonWrapperStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `Tabs` component.
 * Note: The context is only available when the `Tabs` component is rendered as an ancestor.
 * @returns TabsContext - The context for the `Tabs` component.
 * @returns TabsContext.actionsMenuStyleOverrides - Style overrides to be applied to the `ActionsMenu` component.
 */
export const useTabsContext = () => {
  const tabsContext = useContext(TabsContext);
  return tabsContext;
};